const getInvoicesAmountMonth = (invoicesMap) => {
    const isActualMonth = (timeValue) => {
        const inputDate = new Date(timeValue);
        const today = new Date();

        return (
            inputDate.getMonth() === today.getMonth() &&
            inputDate.getFullYear() === today.getFullYear()
        );
    }

    return Object.values(invoicesMap).reduce((acc, invoice) => {
        if (isActualMonth(invoice.invoiceDate)) {
            return acc + (invoice.totalPrice || 0)
        }
        return acc
    }, 0)
}

export default getInvoicesAmountMonth;